// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/three/images/joystick_back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/three/images/joystick_front.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isBrowser_joystick {
  display: none !important;
}

.dynamic_joystick {
  position: absolute;
  display: flex;
  z-index: 1 !important;
  width: 30px;
  height: 30px; 
  bottom: 40px;
  left: 40px;
  transition: all 1s;
}
.dynamic_joystick.IOS{
  bottom: 140px;
}

.joystick_no_event {
  pointer-events: none !important;
  opacity: 0.5 !important;
}

#nipple_0_0 .back {
  all: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-size: contain !important;
  background-color: transparent !important;
  opacity: 1 !important;
}
#nipple_0_0 .front {
  all: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: contain !important;
  background-color: transparent !important;
  opacity: 1 !important;
}
#nipple_1_1 .back {
  all: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-size: contain !important;
  background-color: transparent !important;
  opacity: 1 !important;
}
#nipple_1_1 .front {
  all: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: contain !important;
  background-color: transparent !important;
  opacity: 1 !important;
}

.dynamic_joystick.shows {
  cursor: pointer;
  opacity: 1;
  box-shadow: none !important;
  background-color: transparent !important;
}
.dynamic_joystick.shows {
  height: 0px;
  width: 0px;
}

.dynamic_joystick.noshow {
  pointer-events: none;
  opacity: 0;
}

.dynamic_joystick:hover {
  cursor: grab !important;
}

.Joystick {
  flex: 1 1;
}

.Joystick .debug {
  display: flex;
}
.Joystick ul,
.Joystick li {
  text-align: left;
}

.three-screen .shows {
  box-shadow: none !important;
  background-color: transparent !important;
}

.productCustomizationBar-reload {
  background: #fff;
  position: absolute;
  bottom: 25px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 70px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/controls/Joystick.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oEAAkF;EAClF,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,oEAAmF;EACnF,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,oEAAkF;EAClF,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,oEAAmF;EACnF,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB","sourcesContent":[".isBrowser_joystick {\n  display: none !important;\n}\n\n.dynamic_joystick {\n  position: absolute;\n  display: flex;\n  z-index: 1 !important;\n  width: 30px;\n  height: 30px; \n  bottom: 40px;\n  left: 40px;\n  transition: all 1s;\n}\n.dynamic_joystick.IOS{\n  bottom: 140px;\n}\n\n.joystick_no_event {\n  pointer-events: none !important;\n  opacity: 0.5 !important;\n}\n\n#nipple_0_0 .back {\n  all: none;\n  background-image: url(\"../../../assets/three/images/joystick_back.svg\") !important;\n  background-size: contain !important;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n#nipple_0_0 .front {\n  all: none;\n  background-image: url(\"../../../assets/three/images/joystick_front.svg\") !important;\n  background-size: contain !important;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n#nipple_1_1 .back {\n  all: none;\n  background-image: url(\"../../../assets/three/images/joystick_back.svg\") !important;\n  background-size: contain !important;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n#nipple_1_1 .front {\n  all: none;\n  background-image: url(\"../../../assets/three/images/joystick_front.svg\") !important;\n  background-size: contain !important;\n  background-color: transparent !important;\n  opacity: 1 !important;\n}\n\n.dynamic_joystick.shows {\n  cursor: pointer;\n  opacity: 1;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n.dynamic_joystick.shows {\n  height: 0px;\n  width: 0px;\n}\n\n.dynamic_joystick.noshow {\n  pointer-events: none;\n  opacity: 0;\n}\n\n.dynamic_joystick:hover {\n  cursor: grab !important;\n}\n\n.Joystick {\n  flex: 1;\n}\n\n.Joystick .debug {\n  display: flex;\n}\n.Joystick ul,\n.Joystick li {\n  text-align: left;\n}\n\n.three-screen .shows {\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n\n.productCustomizationBar-reload {\n  background: #fff;\n  position: absolute;\n  bottom: 25px;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 70px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
